/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_addSetEntry.js
 ** module id = 995
 ** module chunks = 1
 **/